import { useT } from "../i18n/hooks.ts";
import { DialogActions } from "./DialogActions.tsx";

export function TabDialogActions({ onSave, onClose }: { onSave: () => void; onClose: () => void }) {
  const t = useT();
  return <DialogActions primary={{ label: t("common.save"), onClick: onSave }} onClose={onClose} />;
}
